'use strict';
import React from 'react';
if (typeof window !== 'undefined') {
    var $ = window.$;
}
import * as ReactRedux from 'react-redux';
import panelActions from '../../redux/panelAction';
import categoryActions from '../../redux/categoryActions';
import marketplaceActions from '../../redux/marketplaceActions';
import inboxActions from '../../redux/inboxAction';
import cartActions from '../../redux/cartActions';
import searchActions from '../../redux/searchActions';
import userActions from '../../redux/userActions';
import { signOut } from '@src/utils/signOut';
import HeaderMenuComponentTemplate from '../layouts/header-menu';
import HeaderLayoutBottomComponent from '../layouts/header-bottom';
import Toastr from 'toastr';
import commonModule from '../../public/js/common';
import ReactGA from 'react-ga';
import { ResponsiveAppBar } from './header/app-bar';
import { TcppModal } from './header/tcpp-modal';
import { OnBoardingRoleSelect } from './header/onboarding-role-select';
import { SmsSubscription } from './header/sms-subscription';
import PropTypes from 'prop-types';
import { ConfirmationDialog } from '@src/components/common/dialogs/confirmation-dialog';
import { setURLState } from '@src/utils/setURLState';

class HeaderLayoutComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            keyword: '',
            showTcppModal: false,
            showSmsSubscription: false,
            privacy: false,
            terms: false,
            showRoleSelectModal: false,
            hasNewTask: false
        };

        this.verifyTCPP = this.verifyTCPP.bind(this);
        this.setTerms = this.setTerms.bind(this);
        this.setPolicy = this.setPolicy.bind(this);
    }

    showMessage(toastStr) {
        if (toastStr.type == 'error') {
            Toastr.error(toastStr.body, toastStr.header);
        } else if (toastStr.type == 'success') {
            Toastr.success(toastStr.body, toastStr.header);
        }

        // Prevent repeat
        const url = new URL(window.location);
        url.searchParams.delete('error');
        window.history.replaceState({}, document.title, url);
    }

    componentDidMount() {
        var self = this;

        if (typeof window !== 'undefined') {
            if ((this.props.panels == null || this.props.panels.length === 0) && this.props.loadPanels != null) {
                this.props.loadPanels();
            }
            if (
                (this.props.categories == null || this.props.categories.length === 0) &&
                this.props.loadCategories != null
            ) {
                this.props.loadCategories();
            }

            if (
                typeof this.props.loadMarketplaceInfo == 'function' &&
                (this.props.logoUrl === '' || typeof this.props.logoUrl == 'undefined' || !this.props.logoUrl)
            ) {
                this.props.loadMarketplaceInfo();
            }
            if (this.props.user) {
                if (typeof this.props.getUnreadCount === 'function') {
                    this.props.getUnreadCount();
                }

                if (typeof this.props.getUserCarts === 'function') {
                    //Pull Guest Cart When Inside Cart page
                    if (this.props.user.Guest !== undefined) {
                        let guestUserID = '';
                        if (commonModule.getCookie('guestUserID') && commonModule.getCookie('guestUserID') !== '') {
                            guestUserID = commonModule.getCookie('guestUserID');
                        }

                        this.props.getUserCarts(
                            { pageSize: 1000, pageNumber: 1, includes: null, guestUserID: guestUserID },
                            null
                        );
                    } else {
                        this.props.getUserCarts({ pageSize: 1000, pageNumber: 1, includes: null }, null);
                    }
                }

                if (typeof this.props.checkUserDetails === 'function') {
                    if (this.props.user && !this.props.user.Guest) {
                        this.props.checkUserDetails(function(data) {
                            self.verifyTCPP(data);
                        });
                    }
                }
            } else {
                //Pull Guest Cart
                if (typeof this.props.getUserCarts === 'function') {
                    let guestUserID = '';

                    if (this.props.user && this.props.user.Guest !== undefined) {
                        if (commonModule.getCookie('guestUserID') && commonModule.getCookie('guestUserID') !== '') {
                            guestUserID = commonModule.getCookie('guestUserID');
                        }
                    }
                    if (!this.props.user) {
                        if (commonModule.getCookie('guestUserID') && commonModule.getCookie('guestUserID') !== '') {
                            guestUserID = commonModule.getCookie('guestUserID');
                        }
                    }

                    this.props.getUserCarts(
                        { pageSize: 1000, pageNumber: 1, includes: null, guestUserID: guestUserID },
                        null
                    );
                }
            }

            if (window.location.search !== '') {
                let keyword = '';
                let hasNewTask = false;

                const urlParams = new URLSearchParams(window.location.search);

                if (urlParams.has('keywords')) {
                    try {
                        keyword = decodeURIComponent(urlParams.get('keywords'));
                    } catch {
                        keyword = unescape(urlParams.get('keywords'));
                    }
                }

                if (urlParams.has('hasNewTask')) {
                    hasNewTask = true;
                    setURLState({ hasNewTask: null });
                }

                this.setState({ keyword, hasNewTask });
            }

            const urlParams = new URLSearchParams(window.location.search);
            const error = urlParams.get('error');
            if (error) {
                if (error == 'unable-to-update-user-info') {
                    self.showMessage({
                        type: 'error',
                        body: 'Unable to update user info.',
                        header: 'Sorry!'
                    });
                } else if (error == 'unable-to-get-user-info') {
                    self.showMessage({
                        type: 'error',
                        body: 'Unable to get user info.',
                        header: 'Sorry!'
                    });
                } else if (error == 'unable-to-sso-login-user') {
                    self.showMessage({
                        type: 'error',
                        body: 'Unable to update sso login.',
                        header: 'Sorry!'
                    });
                } else if (error == 'no-ciam-id-found') {
                    self.showMessage({
                        type: 'error',
                        body: 'No ciam id found.',
                        header: 'Sorry!'
                    });
                } else if (error == 'external-error') {
                    self.showMessage({
                        type: 'error',
                        body: 'An error occured processing your request.',
                        header: 'Sorry!'
                    });
                } else if (error == 'user-info-error') {
                    self.showMessage({
                        type: 'error',
                        body: 'User info retrieval failed.',
                        header: 'Sorry!'
                    });
                } else {
                    self.showMessage({
                        type: 'error',
                        body: error?.replaceAll('-', ' '),
                        header: 'Sorry!'
                    });
                }
            }

            this.bindWindowClick();
            commonModule.init();
            if (self.props.googleAnalytics && self.props.googleAnalytics == null) {
                self.props.loadMarketplaceInfo();
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        commonModule.initHeaderMenuScroll();
    }

    verifyTCPP(data) {
        let showTcppModal = true;
        if (data.CustomFields && data.CustomFields.length > 0) {
            //Check if T&C is present
            let showTermsCondition = !data.CustomFields.some(r => r.Code.includes('-TermsConditions-'));
            let showPrivacyPolicy = !data.CustomFields.some(r => r.Code.includes('-PrivacyPolicy-'));
            let showServiceQualityWaiver = !data.CustomFields.some(r => r.Code.includes('-ServiceQualityWaiver-'));
            showTcppModal = showTermsCondition || showPrivacyPolicy || showServiceQualityWaiver;
        }
        this.setState({
            showTcppModal
        });
    }

    setTerms(e) {
        this.setState({ terms: e.target.checked });
        this.setState({ termVal: e.target.value });
    }

    setPolicy(e) {
        this.setState({ privacy: e.target.checked });
        this.setState({ privacyVal: e.target.value });
    }

    loadGoogleAnalytics() {
        var self = this;
        if (self.props.googleAnalytics) {
            ReactGA.initialize(self.props.googleAnalytics['google-trackid']);
            ReactGA.pageview(window.location.pathname + window.location.search);
        }
    }

    bindWindowClick() {
        const $menu = $('.h-st-menus');
        $(document).mouseup(e => {
            if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
                $menu.hide();
            }
        });
        $(window).on('click', function(e) {
            $('.h-dd-menu').hide();
        });
    }

    searchMobile() {
        $('.header-bottom ul.header-menus > li.h-search').toggle();
        if ($('.header-bottom ul.header-menus > li.h-search').css('display') == 'list-item') {
            $('.h-mobi-search.mobi-show')
                .find('i')
                .removeClass('fa-search')
                .addClass('fa-times');
        } else {
            $('.h-mobi-search.mobi-show')
                .find('i')
                .removeClass('fa-times')
                .addClass('fa-search');
        }
    }

    getGuestUserID() {
        let guestUserID = '';

        if (this.props.user && this.props.user.Guest !== undefined) {
            if (commonModule.getCookie('guestUserID') && commonModule.getCookie('guestUserID') !== '') {
                guestUserID = commonModule.getCookie('guestUserID');
            }
        }
        if (!this.props.user) {
            if (commonModule.getCookie('guestUserID') && commonModule.getCookie('guestUserID') !== '') {
                guestUserID = commonModule.getCookie('guestUserID');
            }
        }
        return guestUserID;
    }

    render() {
        const { showSearchHeader = true } = this.props;

        return (
            <React.Fragment>
                <ResponsiveAppBar
                    unreadCount={this.props.unreadCount}
                    user={this.props.user}
                    signOut={signOut}
                    isPrivateEnabled={this.props.isPrivateEnabled}
                    isMerchantRestrictedOnly={this.props.isMerchantRestrictedOnly}
                    getUnreadCount={this.props.getUnreadCount} // Preserve ootb header dispatch
                />
                {showSearchHeader && (
                    <HeaderLayoutBottomComponent
                        categories={this.props.categories}
                        keyword={this.state.keyword}
                        location={this.state.location}
                        panels={this.props.panels}
                        searchMobile={this.searchMobile}
                        logoUrl={this.props.logoUrl}
                        user={this.props.user}
                        homepageUrl={this.props.homepageUrl}
                        searchGooglePlaces={this.props.searchGooglePlaces}
                    />
                )}
                {this.state.showTcppModal && (
                    <TcppModal
                        open={this.state.showTcppModal}
                        onClose={() => this.setState({ showTcppModal: false })}
                        onShowSmsSubscription={() => this.setState({ showSmsSubscription: true })}
                    />
                )}
                {this.state.showRoleSelectModal && <OnBoardingRoleSelect />}
                {this.state.showSmsSubscription && (
                    <SmsSubscription
                        onClose={() => this.setState({ showRoleSelectModal: true, showSmsSubscription: false })}
                    />
                )}
                {this.state.hasNewTask && (
                    <ConfirmationDialog
                        open={this.state.hasNewTask}
                        onAgree={() => {
                            location.href = '/merchants/order/history';
                        }}
                        agreeLabel='GO TO BOOKED TASKS PAGE'
                        content={{
                            body: 'New Task Request',
                            description: 'Please go to your Purchase Order page and confirm the new task request.'
                        }}
                    />
                )}
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        categories: state.categoryReducer.categories,
        user: state.userReducer.user,
        panels: state.panelsReducer.panels,
        logoUrl: state.marketplaceReducer.logoUrl,
        languages: state.marketplaceReducer.languages,
        homepageUrl: state.marketplaceReducer.homepageUrl,
        unreadCount: state.inboxReducer.unreadCount,
        isPrivateEnabled: state.marketplaceReducer.isPrivateEnabled,
        merchantSubAccountActive: state.marketplaceReducer.merchantSubAccountActive,
        googleAnalytics: state.marketplaceReducer.googleAnalytics,
        isMerchantRestrictedOnly: state.marketplaceReducer.isMerchantRestrictedOnly,
        ControlFlags: state.marketplaceReducer.ControlFlags
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadPanels: () => dispatch(panelActions.asyncLoadingPanels()),
        loadCategories: () => dispatch(categoryActions.asyncLoadingCategories()),
        loadMarketplaceInfo: () => dispatch(marketplaceActions.getInfo()),
        getUnreadCount: () => dispatch(inboxActions.getUnreadCount()),
        searchGooglePlaces: (keyword, callback) => dispatch(searchActions.searchGooglePlaces(keyword, callback)),
        checkUserDetails: callback => dispatch(userActions.checkUserDetails(callback)),
        updateTermsAndAgreement: (data, callback) => dispatch(userActions.updateTermsAndAgreement(data, callback))
    };
}

const HeaderLayout = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(HeaderLayoutComponent);

HeaderLayoutComponent.propTypes = {
    categories: PropTypes.array,
    user: PropTypes.object,
    panels: PropTypes.array,
    logoUrl: PropTypes.string,
    homepageUrl: PropTypes.string,
    unreadCount: PropTypes.number,
    isPrivateEnabled: PropTypes.bool,
    isMerchantRestrictedOnly: PropTypes.bool,
    showSearchHeader: PropTypes.bool,

    // functions
    loadPanels: PropTypes.func,
    loadCategories: PropTypes.func,
    loadMarketplaceInfo: PropTypes.func,
    getUnreadCount: PropTypes.func,
    getUserCarts: PropTypes.func,
    searchGooglePlaces: PropTypes.func,
    checkUserDetails: PropTypes.func
};

export { HeaderLayout, HeaderLayoutComponent };

export default {
    HeaderLayout,
    HeaderLayoutComponent
};
